import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Pelanggan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Pelanggan',
        href: '/adm/customer',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_customer',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'dist_company',
        label: 'ID Distributor',
        sortable: true,
      },
      {
        key: 'cust_code',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'cust_name',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'cust_company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'cust_email',
        label: 'Email',
      },
      {
        key: 'cust_phone',
        label: 'Phone',
      },
      {
        key: 'cust_address',
        label: 'Address',
      },
      {
        key: 'village',
        label: 'Kelurahan',
      },
      {
        key: 'district',
        label: 'Kecamatan',
      },
      {
        key: 'city',
        label: 'Kota',
      },
      {
        key: 'province',
        label: 'Provinsi',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_name: '',
      cust_code: '',
      cust_company: '',
      cust_address: '',
      cust_email: '',
      cust_phone: '',
    },
    import_form: [],
    province: [],
    cities: [],
    districts: [],
    villages: [],
    id_distributor: '',
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeCustomer(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchCustomer(context, params = null) {
    let result = await ApiGetRequest(`customer`, params);
    return !result.error ? result.data.object : [];
  },

  async getProvince({ commit }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiGetRequest(`indo/province`, payload);
    commit('changeCustomer', {
      province: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getCities({ commit }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiGetRequest(`indo/city`, payload);
    commit('changeCustomer', {
      cities: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDistricts({ commit }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiGetRequest(`indo/district`, payload);
    commit('changeCustomer', {
      districts: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getVillages({ commit }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiGetRequest(`indo/village`, payload);
    commit('changeCustomer', {
      villages: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListCustomer({ commit, state }, payload = {}) {
    commit('changeCustomer', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`customer`, params);
      commit('changeCustomer', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_customer.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`customer`, params);
      commit('changeCustomer', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailCustomer({ commit, state }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`customer/${payload.id}/show`);
    commit('changeCustomer', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createCustomer({ commit, state, dispatch }) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiPostRequest(`customer`, state.data.form);
    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCustomer({ commit, state, dispatch }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiPutRequest(`customer/${payload.id}`, state.data.form);

    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCustomer({ commit, dispatch }, payload = null) {
    commit('changeCustomer', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`customer/${payload.id}`);
    commit('changeCustomer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
